import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {

    constructor(
        public auth: AuthService,
        public router: Router,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        
        if (typeof next.data['roles'] != 'undefined') {
            if ((next.data['roles'] as Array<string>).some(rol => rol === 'invitado')) {
                return true;
            }
        }

        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['auth']);

            return false;
        }

        return true;
    }
}
